const UNICODE_SUP: Record<string, string> = {
  '2': '²',
  '3': '³',
  '4': '⁴',
};

/**
 * UCUM / DICOM ascii exponents (^2, cm3, m2, ml/m2, kg/m³, ...) → Unicode ² ³ ⁴.
 * Safe to run on already-normalized strings (idempotent).
 */
export function normalizeUnitSuperscriptsDisplay(unitPart: string): string {
  let s = unitPart.trim();
  if (!s) return s;

  // Carets: cm^2, m^3, ml/m^2
  s = s.replace(/\^([234])(?!\d)/g, (_, d: string) => UNICODE_SUP[d]);

  // Acceleration-style: .../s2, /s3
  s = s.replace(/\/s([234])(?!\d)/gi, (_, d: string) => `/s${UNICODE_SUP[d]}`);

  // Area / volume tokens: mm2, cm³ (already unicode—second pass skips ascii digit), m4, in2…
  s = s.replace(
    /\b(mm|cm|dm|µm|μm|nm|km|in|ft|m)([234])(?!\d)/gi,
    (_, base: string, exp: string) => `${base.toLowerCase()}${UNICODE_SUP[exp]}`
  );

  return s;
}
